"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
function useLoadGsiScript(options = {}) {
    const { onScriptLoadSuccess, onScriptLoadError, locale } = options;
    const [scriptLoadedSuccessfully, setScriptLoadedSuccessfully] = (0, react_1.useState)(false);
    const onScriptLoadSuccessRef = (0, react_1.useRef)(onScriptLoadSuccess);
    onScriptLoadSuccessRef.current = onScriptLoadSuccess;
    const onScriptLoadErrorRef = (0, react_1.useRef)(onScriptLoadError);
    onScriptLoadErrorRef.current = onScriptLoadError;
    (0, react_1.useEffect)(() => {
        const scriptTag = document.createElement('script');
        scriptTag.src = locale
            ? `https://accounts.google.com/gsi/client?hl=${locale}`
            : 'https://accounts.google.com/gsi/client';
        scriptTag.async = true;
        scriptTag.defer = true;
        scriptTag.onload = () => {
            setScriptLoadedSuccessfully(true);
            onScriptLoadSuccessRef.current?.();
        };
        scriptTag.onerror = () => {
            if (window.newrelic) {
                window.newrelic.noticeError(new Error('Failed to load Google Button script'));
            }
            setScriptLoadedSuccessfully(false);
            onScriptLoadErrorRef.current?.();
        };
        document.body.appendChild(scriptTag);
        return () => {
            document.body.removeChild(scriptTag);
        };
    }, []);
    return scriptLoadedSuccessfully;
}
exports.default = useLoadGsiScript;
